document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === "undefined") {
    // eslint-disable-next-line no-console
    console.warn("GSAP not loaded");
    return;
  }

  const scrollTriggerAvailable =
    typeof ScrollTriggerUtils !== "undefined" && ScrollTriggerUtils.register();

  const featuresSection = document.querySelector(".features-section");
  const iconContainer = document.querySelector(".floating-icon-container");

  if (!featuresSection || !iconContainer) {
    return;
  }

  const iconFrames = document.querySelectorAll(
    ".floating-icon-container .icon-frame"
  );

  if (iconFrames.length === 0) {
    return;
  }

  iconFrames.forEach((icon) => {
    gsap.set(icon, {
      opacity: 0,
      scale: 0.92,
      y: 15,
      transformOrigin: "center center",
    });
  });

  if (scrollTriggerAvailable) {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: featuresSection,
        start: "top 80%",
        end: "bottom 20%",
        toggleActions: "play none none none",
        once: true,
      },
    });

    tl.to(iconFrames, {
      opacity: 1,
      scale: 1,
      y: 0,
      duration: 0.5,
      ease: "power1.out",
      stagger: {
        amount: 0.6,
        from: "start",
      },
      force3D: true,
    });

    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        ScrollTrigger.refresh();
      }, 250);
    });
  } else {
    gsap.to(iconFrames, {
      opacity: 1,
      scale: 1,
      y: 0,
      duration: 0.5,
      ease: "power1.out",
      stagger: {
        amount: 0.6,
        from: "start",
      },
      force3D: true,
      delay: 0.2,
    });
  }
});
